/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type { ServicedeskServicesWithoutProjectContextType } from '@jira/spa-apps__servicedesk-services-without-project-context/src/ServicedeskServicesWithoutProjectContextType.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskServicesWithoutProjectContext: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskServicesWithoutProjectContextType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-services-without-project-context", jiraSpaEntry: "async-servicedesk-services-without-project-context" */ '@jira/spa-apps__servicedesk-services-without-project-context/src/ServicedeskServicesWithoutProjectContext.tsx'
			),
	);

const AsyncServicedeskServicesWithoutProjectContext = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskServicesWithoutProjectContext}
		pageId="spa-apps/servicedesk/services"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskServicesWithoutProjectContext;
